'use strict'

import React from 'react'
import { Link } from 'react-router'
import $ from 'jquery'
import TweenMax from 'gsap'

require('styles/Post.less')

let config = require('config');

let expandSVG = require('../images/expand.svg')
let expandCloseSVG = require('../images/expand_close.svg')

class Post extends React.Component
{
  constructor(props) {
    super(props)
  }
  componentDidMount() {
  }
  embedScript(html) {
    var regexp = /<script.*?src="(.*?)"/g
    var match;
    while (match = regexp.exec(html)) {
      var script = document.createElement("script");
      script.src = match[1]
      script.async = true;
      document.body.appendChild(script);
    }
    return <div className="embed_container" dangerouslySetInnerHTML={{__html:html}} />
  }
  render() {
    var { post, cat, type } = this.props
    var self = this
    if (post)
    {
      var imgList = []
      var count = 0
      post.acf.body_content.map(function(content)
      {
        if (content.acf_fc_layout == 'body_main_image')
        {
          imgList.push(content.body_main_image.url)
        }
      })
      for (var i = 0; i < imgList.length; i++)
      {
        var image = new Image()
        image.onload = function()
        {
          count++
          if (count == imgList.length)
          {
            this.resize()
          }
        }.bind(this)
        image.src = imgList[i]
      }
      // iframe
      setTimeout(function(){
        $('.body_youtube iframe, .embed .issuuembed, .embed iframe').each(function(){
          var w = $(this).width()
          var h = $(this).height()

          if (!$(this).data("w")) {
            $(this).attr("data-w", w)
          } else {
            w = $(this).data("w")
          }
          if (!$(this).data("h")) {
            $(this).attr("data-h", h)
          } else {
            h = $(this).data("h")
          }

          var ww = $(window).width()
          var rw, rh
          if (ww < 640)
          {
            rw = ww - 10.0
          }
          else
          {
            rw = ww * 0.525
          }
          if (rw > 900) rw = 900
          rh = parseFloat(rw / w) * h
          $(this).css({
            width:rw,
            height:rh
          })
        })
        self.resize()
      }, 300)
    }
    this.resize()
    return (
      <div className='post'>
        { post ?
            <div className='inner'>
              { type == 'list' ?
                <h2 className='title'>
                  <div className='inner'>
                    <Link to={'/' + post.slug}>{ post.title.rendered }</Link>
                  </div>
                </h2>
              :
                <h1 className='title'>
                  <div className='inner'><a>{ post.title.rendered }</a></div>
                </h1>
              }
              { post.acf.original_date ?
                <div className='date'>{ post.acf.original_date }</div>
              :null }
              <div className='tag'>
                { type == 'preview' ?
                  <div className='inner'>
                    { post.cat }
                  </div>
                :
                  cat ?
                    cat.map(function(c, i) {
                      return (
                        <div className='inner' key={i}>
                        { post.categories[0] == c.id ?
                          c.name
                        :null }
                        </div>
                      )
                    })
                  :null
                }
              </div>
              <div className='blocks'>
                { post.acf.body_content.map(function(content, i) {
                  var style, max
                  if (content.acf_fc_layout == 'body_main_image')
                  {
                    if (content.body_main_image_type == 'メイン(横位置)')
                    {
                      max = 1920
                    }
                    else if (content.body_main_image_type == 'メイン(縦位置)')
                    {
                      max = 1200
                    }
                    else
                    {
                      max = 900
                    }
                    var w = content[content.acf_fc_layout]['width']
                    if (w > max) style = {maxWidth:max}
                    else style = {maxWidth:w}
                  }
                  return (
                    <div className={content.acf_fc_layout + ' block'} key={i}>
                    { content.acf_fc_layout == 'body_main_image' ?
                      <div className='image'>
                      { content.body_main_image_type == 'メイン(横位置)' ?
                        <div className='full-image'>
                          <img className='visual' src={content[content.acf_fc_layout]['url']} style={style} />
                          { content.body_main_image_caption ?
                            <div className={ content[content.acf_fc_layout]['url'] ? 'caption':'caption mt0' } style={style} dangerouslySetInnerHTML={{__html: content.body_main_image_caption}} />
                          : null}
                        </div>
                      : content.body_main_image_type == 'メイン(縦位置)' ?
                        <div className='button-image'>
                          <img className='visual' src={content[content.acf_fc_layout]['url']} style={style} />
                          <a className='sizebutton' onClick={self.expand}><img src={expandSVG} /></a>
                          { content.body_main_image_caption ?
                            <div className={ content[content.acf_fc_layout]['url'] ? 'caption':'caption mt0' } style={style} dangerouslySetInnerHTML={{__html: content.body_main_image_caption}} />
                          : null}
                        </div>
                      :
                        <div className='inline-image'>
                          <img className='visual' src={content[content.acf_fc_layout]['url']} style={style} />
                          { content.body_main_image_caption ?
                            <div className={ content[content.acf_fc_layout]['url'] ? 'caption':'caption mt0' } style={style} dangerouslySetInnerHTML={{__html: content.body_main_image_caption}} />
                          : null}
                        </div>
                      }
                      </div>
                    : content.acf_fc_layout == 'talks' ?
                        <div>
                          { content["talks_texts"].map(function(talk, i) {
                            return (
                              <div key={i} className='talk'>
                                <p className='name'>{ talk.name }</p>
                                <div className='text' key={i} dangerouslySetInnerHTML={{__html: talk.talk_text}} />
                              </div>
                            )
                          })}
                        </div>
                    : content.acf_fc_layout == 'embed' ?
                        <div className="embed_set">
                          { self.embedScript(content["embed"]) }
                          { content.embed_caption ?
                            <span className='caption' dangerouslySetInnerHTML={{__html: content.body_main_image_caption}} />
                          :null }
                        </div>
                    :
                      <div>
                        <div dangerouslySetInnerHTML={{__html: content[content.acf_fc_layout]}} />
                        { content.body_youtube_caption ?
                          <span className='caption' dangerouslySetInnerHTML={{__html: content.body_main_image_caption}} />
                        :null }
                      </div>
                    }
                    </div>
                  )
                })}
              </div>
              <div className='share'>
                <div className='left name'>Share With</div>
                <div className='buttons'>
                  <span className='tw link'><a onClick={(e)=>this.shareTw('http://twitter.com/share?url=http://' + location.host + '/' + post.slug + '&text=' + post.title.rendered + "｜" + config.default.SITE_NAME)}>Twitter</a></span>
                  <span className='or'> or </span>
                  <span className='fb link'><a onClick={this.shareFb.bind(this)}>Facebook</a></span>
                  <span className='line link'><a href={'http://line.me/R/msg/text/?' + post.title.rendered + "｜" + config.default.SITE_NAME + ' http://' + location.host + '/' + post.slug }>LINE</a></span>
                </div>
              </div>
            </div>
        : null }
      </div>
    )
  }
  resize()
  {
  }
  shareTw(url)
  {
    var left = (window.screen.width - 550) / 2
    var top  = (window.screen.height - 450) / 2
    var w    = 'tweetwindow'
    window.open(encodeURI(decodeURI(url)), w, 'width=550, height=450, top=' + top + ', left=' + left + ', personalbar=0, toolbar=0, scrollbars=1, resizable=1');
  }
  shareFb()
  {
    var post = this.props.post
    var thumbnail;
    if (post.acf.thumbnail)
    {
      thumbnail = post.acf.thumbnail
    }
    else
    {
      thumbnail = config.default.HOST + '/assets/ogimage.jpg'
    }
    var description = ''
    post.acf.body_content.map(function(content)
    {
      if (content.acf_fc_layout == 'body_main_text')
      {
        description = content[content.acf_fc_layout].replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '')
        if (description.length > 80) description = description.substr(0, 80) + '...'
      }
    });
    FB.ui({
      display:'popup',
      method:'feed',
      link:config.default.HOST + '/' + post.slug,
      picture:thumbnail,
      name:post.title.rendered,
      description:description
    })
  }
  expand(e)
  {
    var expand= $(e.target).closest('.button-image')
    if (expand.hasClass('expand'))
    {
      expand.removeClass('expand')
      expand.find('a img').attr('src', expandSVG)
    }
    else
    {
      expand.addClass('expand')
      expand.find('a img').attr('src', expandCloseSVG)
      var t = expand.offset().top - 90
      TweenMax.to('body, html', 0.6, {scrollTop:t, ease:'easeInOutExpo'})
    }
  }
}

Post.defaultProps = {
}

Post.displayName = 'Post'

export default Post



// WEBPACK FOOTER //
// ./src/components/PostComponent.js